import { Controller } from '@hotwired/stimulus'
import { loadFilePond } from '../models/filepond_loader'

export default class GifpickerController extends Controller {
  static targets = ['modal', 'search', 'results', 'gifUrl']

  connect() {
    this.debounceTimer = null
    if (globalThis.location.pathname.includes('messages')) {
      this.fetchGifs('trending', this.element.dataset.index)
    }
  }

  openModal(event) {
    event.preventDefault()
    const index = event.currentTarget.dataset?.index
    this.element.dataset.index = index

    if (event.target.dataset?.edit === 'true') {
      const oldModalElement = document.getElementById('shareRecipeModal')
      console.log('old', oldModalElement)
      const oldModal = new bootstrap.Modal(oldModalElement)
      oldModal.hide()
    }

    const modalElement = document.getElementById('gifPickerModal' + index)
    const modal = new bootstrap.Modal(modalElement)
    modal.show()
    // clear search value when close the modal
    const searchInput = this.element.querySelector(
      "[data-gifpicker-target='search']"
    )
    if (searchInput) searchInput.value = ''
    this.fetchGifs('trending', index)
  }

  closeModal(index) {
    const modalElement = $('#gifPickerModal' + index)
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement)
      if (modal) {
        modal.hide()
      } else {
        console.error('Bootstrap modal instance not found!')
      }
    } else {
      console.error('Modal target not found!')
    }

    this.resultsTarget.innerHTML = ''
  }

  searchGifs(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      return
    }
    const query = event.target.value
    const index = event.target.dataset?.index
    if (query.length > 2) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.fetchGifs(query, index)
      }, 500)
    }
  }

  fetchGifs(query, index = false) {
    fetch(`/posts/search_gif?query=${encodeURIComponent(query)}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.success) {
          document.getElementById(
            index ? 'results_' + index : 'results'
          ).innerHTML = data.gifs
            .map(
              (gif) => `
            <div class="col-xl-2 col-lg-3 col-sm-4 col-6">
            <img src="${gif.url}"
                 class="img-fluid object-fit-contain bg-black rounded cursor-pointer h-150px w-100"
                 data-url="${gif.url}"
                 data-action="click->gifpicker#selectGif"
                 data-index="${index}"></div>
          `
            )
            .join('')
        } else {
          this.showAlert(
            'Oops!',
            'There was an issue fetching GIFs. Please try again later.',
            'error'
          )
        }
      })
      .catch((error) => {
        console.error('Error fetching GIFs:', error)
        this.showAlert(
          'Network Error',
          'Please check your connection and try again.',
          'warning'
        )
      })
  }

  async selectGif(event) {
    const messageGif = globalThis.location.pathname.includes('messages')
    event.currentTarget.classList.add('disabled')
    const url = event.target.dataset.url
    const index = event.target.dataset.index

    const target =
      document.getElementById(`post_medias_${index}`) ||
      document.getElementById('new_message')

    if (target) {
      let filePond
      const FilePond = await loadFilePond()
      if (!messageGif) {
        $(target).removeClass('d-none')
        filePond = FilePond.find(target)

        if (!filePond) {
          filePond = FilePond.create(target, {
            beforeRemoveFile: (item) => {
              return new Promise((resolve, reject) => {
                this.showAlert(
                  'Confirmation',
                  'Are you sure? you want to remove this file?',
                  'warning'
                ).then((result) => {
                  if (result.isConfirmed) {
                    this.isValid()
                    resolve()
                  } else {
                    reject()
                  }
                })
              })
            }
          })
        }
      }

      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], `gif_image_${index}.gif`, {
            type: 'image/gif'
          })
          if (messageGif) {
            const messagePreviewController =
              this.application.getControllerForElementAndIdentifier(
                document.getElementById('new_message'),
                'message-preview'
              )
            if (messagePreviewController) {
              const attachement = document.getElementById('message_attachments')
              const currentFiles = Array.from(attachement.files)
              if (currentFiles.length >= 5) {
                const modal = bootstrap.Modal.getInstance(
                  $('#shareRecipeModal')
                )
                if (modal) modal.hide()
                $('.show_error')
                  .html('You can upload max 5 attachments')
                  .addClass('text-danger')
                return
              }
              const dt = new DataTransfer()

              for (let f of attachement.files) {
                dt.items.add(f)
              }
              dt.items.add(file)

              attachement.files = dt.files
              messagePreviewController.selectFile({}, file)
              const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
              if (modal) modal.hide()
            }
          } else {
            filePond
              .addFile(file)
              .then(() => {
                if (
                  $('.edit-post-details[data-index="' + index + '"]').length ===
                  0
                ) {
                  this.closeModal(index) // close gif modal after adding the gif for comment
                }
              })
              .catch((err) => {
                console.error('Error adding file to FilePond:', err)
                this.showAlert('Error', 'Failed to add GIF to post.', 'error')
              })
          }
        })
        .catch((err) => {
          console.error('Error fetching GIF:', err)
          this.showAlert('Error', 'Failed to load GIF.', 'error')
        })
    } else {
      console.error(`Target element post_medias_${index} not found`)
      this.showAlert('Error', 'Could not find media upload area.', 'error')
    }
  }

  showAlert(title, message, icon) {
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: 'OK'
    })
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
  }
}
